import {z} from "zod/v4-mini"
import {uvValue, vectorValue} from "#template/nodes/validation"

export const controlPointCommon = z.object({
    corner: z.boolean(),
    sectionBreak: z._default(z.boolean(), false),
})

export const positionControlPoint = z.extend(
    z.object({
        position: vectorValue,
        normal: vectorValue,
    }),
    controlPointCommon.shape,
)

export const uvControlPoint = z.extend(
    z.object({
        uv: uvValue,
    }),
    controlPointCommon.shape,
)

export function isUVControlPoint(x: unknown): x is {corner: boolean; sectionBreak?: boolean; uv: [number, number]} {
    return uvControlPoint.safeParse(x).success
}

export const planarCurveControlPoint = z.extend(
    z.object({
        position: z.tuple([z.number(), z.number()]),
    }),
    controlPointCommon.shape,
)

export const curveParametersCommon = z.object({
    closed: z.boolean(),
    resolution: z.optional(z.number()),
})
